import TabNotes from './TabNotes';

export default TabNotes;
